import React from 'react'

type GameBtnProps = {
  children?: React.ReactNode
  arrow?: boolean
  className?: string
  onClick?: () => void
  disabled?: boolean
}
export default function GameBtn({ children, arrow = false, className, onClick, disabled = false }: GameBtnProps) {
  return (
    <button className={`game-btn ${className}`} onClick={onClick} disabled={disabled}>
      <div>{children}</div>
      {arrow && (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M0.550049 14L5.55005 7L0.550049 0H3.00005L8.00005 7L3.00005 14H0.550049ZM6.50005 14L11.5 7L6.50005 0H8.95005L13.95 7L8.95005 14H6.50005Z" />
        </svg>
      )}
    </button>
  )
}
